import { CardBase } from '@facephi/ui-react';
import styled from 'styled-components';

export const RiskCard = styled(CardBase)`
  padding-bottom: 6.8rem;
`;
